import { render, staticRenderFns } from "./AssetsBox.vue?vue&type=template&id=0d9737de&scoped=true&"
import script from "./AssetsBox.vue?vue&type=script&lang=js&"
export * from "./AssetsBox.vue?vue&type=script&lang=js&"
import style0 from "./AssetsBox.vue?vue&type=style&index=0&id=0d9737de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9737de",
  null
  
)

export default component.exports